import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './MedicationMore.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import { useLocation } from 'react-router-dom';
import ToastPopup from '../../../../../components/comm/ToastPopup';

const MedicationMore = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const prscrptnGbn = location.state?.prscrptnGbn;

    const isFirstRender = useRef(true);

    const [prscrptnList, setPrscrptnList] = useState([]);
    const [prscrptnDetailList, setPrscrptnDetailList] = useState([]);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            retrieveSummaryViewInfo(prscrptnGbn);
            return;
        }
    }, []);

    const retrieveSummaryViewInfo = useCallback(async (prscrptnGbn) => {
        if (!prscrptnGbn) return;

        const url = "/mypage/retrievePrscrptnDetail";

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: jToken,
            },
        }

        await axiosApi.post(url, {prscrptnGbn : prscrptnGbn}, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setPrscrptnList([...res.data.result.prscrptnList]);
                setPrscrptnDetailList([...res.data.result.prscrptnDetailList]);
            } else {
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            console.error("주요 약물력 상세 호출 중 오류  : ", err);
        })
    }, []);
    
    return (
        <>
            <HeadSub title="주요 약물력" />

                <div id="sub-content">
                    <div className='inner-wrap' data-padding="0">

                        <div className={style['top-box']}>
                            <div className={style['head-title']} data-pill="1">
                                <div>
                                    <strong>{prscrptnGbn === '1' ? '스테로이드제' : prscrptnGbn === '2' ? '항혈전제' : '향정신제'}</strong>
                                    <span>최근 1년간 아래 약물의 처방 이력이 있어요.</span>
                                </div>
                            </div>
                            <div className={style['head-list']}>
                                <ul>
                                    {prscrptnList.length > 0 &&
                                        prscrptnList.map((item, _idx)=> {
                                            return(<li>{item.prscrptnNm}</li>)
                                        })
                                    }
                                </ul>
                            </div> 
                        </div>

                        <div className={style['bottom-box']}>
                            <div className={style['drugs-list-box']}>
                                <ul>
                                    {prscrptnDetailList.length > 0 &&
                                        prscrptnDetailList.map((item, _idx)=> {
                                            return(
                                                <li>
                                                    <p>{item.prscrptnNmArr}</p>
                                                    <div className={style['span-box']}>
                                                        <span>{item.prscrptnDt}</span>
                                                        <span>{item.hsptlNm}</span>
                                                    </div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {toast && (
                    <ToastPopup
                        setToast={setToast}
                        message={toastMessage}
                        position="center"
                        opacity="90"
                    />
                )}
            
        </>
    );
};

export default MedicationMore;
